var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{style:(_vm.bigScreenStyle)},_vm._l((_vm.tempList),function(widget,index){return _c('widget',{key:index,attrs:{"type":widget.type},model:{value:(widget.value),callback:function ($$v) {_vm.$set(widget, "value", $$v)},expression:"widget.value"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }